<template>
    <div class="ReviewCard">
        <div class="flex v-center">
            <img
                :src="review.reviewer.avatar_url"
                :alt="review.reviewer.name"
                class="spark-profile-photo-md m-r-lg"
            />
            <div class="flex-1">
                <h5 class="m-t-xs m-b-none">
                    {{ review.reviewer.name }}
                </h5>
                <span class="text-lighter small">{{ review.reviewable.jobable.name }}</span>
            </div>
            <div>
                <platform-icon :platform="review.reviewable.jobable.platform"></platform-icon>
            </div>
        </div>

        <div class="ReviewCard__body m-t-lg m-b-lg text-light italic">
            <text-block :value="review.body"></text-block>
        </div>

        <div class="flex v-bottom">
            <div class="flex-1">
                <rating-stars v-model="review.score" :disabled="true"></rating-stars>
                <span class="text-lighter small"> {{ rating }} stjerner </span>
            </div>
            <div class="text-lighter small">
                {{ review.created_at | moment('D. MMM. YYYY') }}
            </div>
        </div>

        <div v-if="hasFooter" class="-m-l-lg -m-r-lg -m-b-lg">
            <slot name="footer" :review="review"></slot>
        </div>
    </div>
</template>

<style lang="less" type="text/less">
@import '~dashboard-less/variables';

.ReviewCard {
    font-size: 16px;

    h5 {
        font-weight: bold;
        font-style: italic;
        font-size: 16px;
    }

    .PlatformIcon {
        font-size: 40px;
    }

    .ReviewCard__body {
        .TextBlock {
            display: inline-block;
        }
    }

    .RatingStars {
        font-size: 21px;
        display: inline-block;
    }
}
</style>

<script type="text/babel">
export default {
    props: ['review'],

    data() {
        return {}
    },

    computed: {
        hasFooter() {
            return typeof this.$scopedSlots.footer !== 'undefined'
        },

        rating() {
            return parseInt(this.review.score)
        },
    },

    mounted() {
        // setTimeout(() => this.autosize(this.$refs.inputReview), 500);
    },

    methods: {},
}
</script>
